'use client';

import React, { useEffect, useRef } from 'react';

export default function ScrollProgress() {
  const barRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const update = () => {
      if (!barRef?.current) return;
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement?.scrollHeight - window.innerHeight;
      const progress = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
      barRef.current.style.width = `${progress}%`;
    };
    window.addEventListener('scroll', update, { passive: true });
    return () => window.removeEventListener('scroll', update);
  }, []);

  return (
    <div data-component-id="src/app/components/ScrollProgress.tsx:21:4" data-component-path="src/app/components/ScrollProgress.tsx" data-component-line="21" data-component-end-line="26" data-component-file="ScrollProgress.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22scroll-progress%22%7D"
      ref={barRef}
      className="scroll-progress"
      style={{ width: '0%' }}
      aria-hidden="true"
    />
  );
}